import { ApiBase } from 'api/api'
import { makeGetRequest } from 'api/fetchCalls'
import type { PlansResponse } from 'types/payments'

export async function getPlans(): Promise<PlansResponse> {
  return await makeGetRequest(ApiBase + `/payments/plans`)
}
